<template>

      <TuiCalendar 
          ref="tuiCalendar"
          :isReadOnly="false"
          class="my-calendar"
          :timezone="host_timezone"
          :view="calendar_settings.default_view"
          :use-form-popup="false"
          :useDetailPopup="false"
          :week="options.week"
          :month="options.month"
          :calendars="views"
          :events="filteredEvents"
          :class="{'border-left' : calendar_settings.default_view == 'month' }"
        />
        
      <EventDetailsPopup ref="eventDetailsPopup" :host="host"/>
      
      <NewEventForm ref="newEventForm" @close="clearSelectedSlot" />
      
  
</template>

<script>
import TuiCalendar from 'toast-ui-calendar-vue3';
import EventDetailsPopup from "controllers/vue_components/calendar/event_details_popup"
import NewEventForm from "controllers/vue_components/calendar/new_event_form"
import { useCalendarStore } from 'controllers/vue_components/calendar/store'
import Constants from "controllers/vue_components/mixins/constants"

export default {
    name: 'MyCalendar',
    components: {
        TuiCalendar, EventDetailsPopup, NewEventForm
    },
    mixins: [Constants],
    props: ['host', 'calendar_settings'],
    data() {
        return {
            events_by_id: {},
            events: [],
            parsed_host: {
                date_timezone: 'Etc/UTC',
            },
            filterData: {
                selected_date: new Date(),
            },
            // https://github.com/nhn/tui.calendar/blob/main/docs/en/guide/getting-started.md#creating-an-instance
            host_timezone: {}
        };
    },
    methods: {
        useCalendarStoreObj() {
            return useCalendarStore();
        },

        gotoSpecificDate(target_date) {
            const calendarComponent = this.$refs.tuiCalendar;
            const calendarInstance = calendarComponent.getInstance();
            if (calendarInstance && typeof calendarInstance.setDate === 'function') {
                calendarInstance.setDate(target_date);
            }
        },

        gotoSpecificView(target_view) {
            this.calendar_settings.default_view = target_view
        },

        parsedHost() {
            return JSON.parse(this.host);
        },

        updateData(events_data, filters) {
            this.events_by_id = events_data.events_by_id
            this.events = events_data.events
            this.filterData = filters;
        },

        clearSelectedSlot() {
            const calendarComponent = this.$refs.tuiCalendar;
            const calendarInstance = calendarComponent.getInstance();
            if (calendarInstance && typeof calendarInstance.clearGridSelections === 'function') {
                calendarInstance.clearGridSelections();
            }
        },

    },

    mounted() {
        const calendarComponent = this.$refs.tuiCalendar;
        const calendarInstance = calendarComponent.getInstance();

        calendarInstance.on('clickEvent', (event) => {
            this.$refs.eventDetailsPopup.toggleModal()
            let clicked_event = this.events_by_id[event.event.id]
            this.$refs.eventDetailsPopup.updateEventData(clicked_event , event)
        });
        
        calendarInstance.on('selectDateTime', (event) => {
            this.$refs.newEventForm.toggleModal()
            this.$refs.newEventForm.updateEventData(event)
        });

        function getDayName(dayIndex) {
            const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
            return daysOfWeek[dayIndex];
        }

        if (calendarInstance && typeof calendarInstance.setTheme === 'function') {
            calendarInstance.setTheme({
                week: {
                    today: {
                        color: 'rgb(26,115,232)',
                    },
                    pastDay: {
                        color: '#70757a',
                    },
                },
            });

            const parsedHost = this.parsed_host;

            calendarInstance.setOptions({
                template: {
                    weekDayName(model) {
                        const today = new Date();
                        const isToday = model.dayName === getDayName(today.getDay()) && model.date === today.getDate();

                        const dayNameStyle = isToday ? 'color: rgb(26,115,232); height: 20px; font-size: 10px ' : 'height: 20px; font-size: 10px';
                        const dateStyle = isToday
                            ? 'background-color: rgb(26,115,232); color: white; display: inline-block; width: 34px; height: 34px; line-height: 34px; text-align: center; border-radius: 100%; font-weight: 400; font-size: 18px; margin-top: -3px;'
                            : 'display: inline-block; width: 34px; height: 34px; line-height: 34px; text-align: center; font-weight: 400; font-size: 18px; margin-top: -3px;';

                        return `<div style="${dayNameStyle}">${model.dayName.toUpperCase()}</div><div style="${dateStyle}">${model.date}</div>`;
                    },


                    timegridNowIndicatorLabel: ({time}) => {
                        const date = new Date(time);
                        const options = {
                            hour12: (this.calendar_settings.time_format === '12_hours'),
                            hour: 'numeric',
                            minute: 'numeric'
                        };

                        if (this.calendar_settings.time_format === '12_hours') {
                            if (date.getHours() === 12) {
                                return `12:${date.getMinutes()} PM`
                            }
                        }

                        return date.toLocaleTimeString(undefined, options);
                    },

                    timegridDisplayPrimaryTime: ({time}) => {
                        const date = new Date(time);
                        const options = {
                            hour12: (this.calendar_settings.time_format === '12_hours'),
                            hour: 'numeric'
                        };

                        if (this.calendar_settings.time_format === '12_hours') {
                            if (date.getHours() === 12 && date.getMinutes() === 0) {
                                return '12 PM';
                            }
                        }

                        return date.toLocaleTimeString(undefined, options);
                    },
                    timegridDisplayTime: ({time}) => {
                        const date = new Date(time);
                        const options = {
                            hour12: (this.calendar_settings.time_format === '12_hours'),
                            hour: 'numeric'
                        };

                        if (this.calendar_settings.time_format === '12_hours') {
                            if (date.getHours() === 12 && date.getMinutes() === 0) {
                                return '12 PM';
                            }
                        }

                        return date.toLocaleTimeString(undefined, options);
                    },
                    popupDetailAttendees({attendees = []}) {
                        return attendees.join('\n');
                    },
                    time(event) {
                        const startTime = new Date(event.start);
                        const options = {
                            hour: 'numeric',
                            minute: 'numeric',
                            hour12: (parsedHost.time_format === '12_hours'),
                        };

                        const formattedStartTime = startTime.toLocaleTimeString(undefined, options);

                        return `<span style="font-weight: 500;">${event.title},</span>&nbsp;<span>${formattedStartTime}</span>`;
                    },
                    popupDetailDate({start, end}) {
                        const startDate = new Date(start);
                        const endDate = new Date(end);

                        const optionsDay = {
                            weekday: 'long',
                        };

                        const optionsDateTime = {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: 'numeric',
                            minute: 'numeric',
                            hour12: (parsedHost.time_format === '12_hours'),
                        };

                        const formattedStartDay = startDate.toLocaleString('en-US', optionsDay);
                        const formattedEndDay = endDate.toLocaleString('en-US', optionsDay);

                        if (formattedStartDay === formattedEndDay) {
                            const formattedStart = startDate.toLocaleString('en-US', optionsDateTime);
                            const formattedEnd = endDate.toLocaleString('en-US', {
                                hour: 'numeric',
                                minute: 'numeric',
                                hour12: (parsedHost.time_format === '12_hours')
                            });

                            return `${formattedStart} - ${formattedEnd}`;
                        } else {
                            const formattedStart = startDate.toLocaleString('en-US', optionsDateTime);
                            const formattedEnd = endDate.toLocaleString('en-US', optionsDateTime);

                            return `${formattedStart} - ${formattedEnd}`;
                        }
                    },
                },
            });
        }
    },
    computed: {
        filteredEvents() {
            if (this.events.length > 0 && this.filterData.calendars_list) {
                // Extract active calendarIds
                const activeCalendarIds = this.filterData.calendars_list
                    .filter(calendar => calendar.active)
                    .map(calendar => calendar.calendarId);

                const selectedEvent = this.useCalendarStoreObj().selected_event; // Assuming you have a method to get the selected event

                // Filter bookings with active calendar IDs
                const activeCalendarBookings = this.events.filter(event => {
                    return activeCalendarIds.includes(event.calendarId);
                });

                let timelydoBookings = [];
                if (selectedEvent === 'all_events') {
                    timelydoBookings = this.events.filter(booking => {
                        return booking.calendarId === 'timelydo_booking';
                    });
                } else if (selectedEvent === 'none') {
                    timelydoBookings = []
                } else {
                    timelydoBookings = this.events.filter(booking => {
                        return booking.event_id === selectedEvent;
                    });
                }

                return [...activeCalendarBookings, ...timelydoBookings];

            } else {
                return [];
            }
        },
        options() {
            return {
                week: {
                    dayNames: this.useCalendarStoreObj().days_list,
                    startDayOfWeek: this.calendar_settings.start_day_of_week,
                    narrowWeekend: this.calendar_settings.narrow_weekend,
                    workweek: this.calendar_settings.show_only_work_week,
                    showNowIndicator: this.calendar_settings.show_now_indicator,
                    hourStart: 0,
                    hourEnd: 24,
                    eventView: ['time'],
                    taskView: false,
                    collapseDuplicateEvents: this.calendar_settings.collapse_duplicate_events,
                },
                month : {
                    dayNames: this.useCalendarStoreObj().days_list,
                    workweek: this.calendar_settings.show_only_work_week,
                    narrowWeekend: this.calendar_settings.show_only_work_week,
                    startDayOfWeek: this.calendar_settings.start_day_of_week,
                    visibleEventCount: 6,
                },
            }
        },

        views() {
            return [
                {
                    id: 'home',
                    name: 'Home',
                    backgroundColor: '#69ff7061',
                    borderColor: '#69ff7061',
                    dragBackgroundColor: '#69ff7061',
                },
                {
                    id: 'work',
                    name: 'Work',
                    backgroundColor: '#2d9fff61',
                    borderColor: '#2d9fff61',
                    dragBackgroundColor: '#2d9fff61',
                },
            ]
        },


    },
    created() {
        this.parsed_host = JSON.parse(this.host)
        console.log(this.calendar_settings.date_primary_timezone)
        this.host_timezone = {
            zones: [
                {
                    timezoneName: this.calendar_settings.date_primary_timezone,
                    displayLabel: this.calendar_settings.formatted_label_for_primary_timezone,
                },
            ],
        }

        if(this.calendar_settings.date_secondary_timezone !== null) {
            this.host_timezone.zones.push({
                timezoneName: this.calendar_settings.date_secondary_timezone,
                displayLabel: this.calendar_settings.formatted_label_for_secondary_timezone,
            })
        }
    },
    watch: {
        'filterData.selected_date'(newValue) {
            this.gotoSpecificDate(newValue)
        },
        'filterData.calendar_view'(newValue) {
            this.gotoSpecificView(newValue)
        }
    }
};
</script>
